export default "__VITE_ASSET__B5Wb3sXo__"